import { Grid } from "@radix-ui/themes"
import {
  Layers,
  Calendar,
  Users,
  Shield,
  TrendingUp,
  Zap,
} from "lucide-react"
import StatsCard from "./StatsCard"
import { AdminStats } from "@/types/shared"

interface StatsGridProps {
  stats: AdminStats
}

export default function StatsGrid({ stats }: StatsGridProps) {
  return (
    <Grid columns={{ initial: "1", md: "2", lg: "6" }} gap="4" mb="6">
      <StatsCard
        label="Tracks"
        count={stats.total_tracks}
        icon={Layers}
        href="/admin/tracks"
      />
      <StatsCard
        label="Clubs"
        count={stats.total_clubs}
        icon={Zap}
        href="/admin/clubs"
      />
      <StatsCard label="Events" count={stats.total_events} icon={Calendar} />
      <StatsCard label="Users" count={stats.total_users} icon={Users} />
      <StatsCard
        label="Track Managers"
        count={stats.total_track_managers}
        icon={Shield}
        href="/admin/track_managers"
      />
      <StatsCard
        label="Published Events"
        count={stats.published_events}
        icon={TrendingUp}
      />
    </Grid>
  )
}
